import { render } from "./AboutUs.vue?vue&type=template&id=25fcf16e&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=ts"
export * from "./AboutUs.vue?vue&type=script&lang=ts"

import "./AboutUs.vue?vue&type=style&index=0&id=25fcf16e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-25fcf16e"

export default script